import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';

@Injectable({
    providedIn: 'root'
})
export class BpgMembershipService {



    constructor(private readonly http: HttpClient,
        // private logger: BPGLoggerService,
        private readonly bpgCommonService: BpgCommonService) { }

    URI: string = ConstantValues.userManagementApiUrl.userManagementUrl;
    bpgApi: string = ConstantValues.membershipApiUrl.bpgList;
    interestApi: string = ConstantValues.membershipApiUrl.interestList;
    skillsApi: string = ConstantValues.membershipApiUrl.skillsList;
    demographicApi: string = ConstantValues.membershipApiUrl.demographicLIst;
    membershipFormSaveApi: string = ConstantValues.membershipApiUrl.membershipSaveApi;
    retrieveDetailsOfMembershipForm: string = ConstantValues.membershipApiUrl.retrieveDetailsOfMembershipForm;
    landingDto: any = ConstantValues.membershipApiUrl.landingDto;
    virtualBpgUrl: string = ConstantValues.membershipApiUrl.excludeBpgApi;
    retrieveUserDetailsOfGroupMembership: string = ConstantValues.userManagementApiUrl.getMembershipGroupSignUpUserDetails;
    saveUserDetailsOfGroupMembership: string = ConstantValues.userManagementApiUrl.saveMemberhsipGroupDetails;
    saveAdminBpgSettings: string = ConstantValues.userManagementApiUrl.saveAdminBpgSettings;
    pastEnrollmentListApi: string = ConstantValues.userManagementApiUrl.getPastEnrollmentList;
    enrollmentDeleteApi: string = ConstantValues.userManagementApiUrl.deleteEnrollment;
    /** For service call to get bpg list
    * @class MembershipService
    * @method getAllBpg
    * @param landingData
    * @returns Observable
    */
    public getAllBpg(landingDTOModel): Observable<any> {
        return this.http.post(this.URI + this.bpgApi, landingDTOModel, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
            return data;

        })).pipe(catchError((error: any) => {
            throw of(error);
        }))

    }

    /** For service call to get bpg list
    * @class MembershipService
    * @method getExcludedBpg
    * @param userId
    * @returns Observable
    */
    public getAllVirtualBpg(params): Observable<any> {

        return this.http.get(this.URI + this.virtualBpgUrl + params, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
            return data;
        })).pipe(catchError((error: any) => {
            throw of(error);
        }))

    }

    /** For service call to get areas of impact
   * @class MembershipService
   * @method getAreasOfImpact
   * @param landingData
   * @returns Observable
   */
    public getAreasOfImpact(): Observable<any> {
        return this.http.post(this.URI + this.interestApi, this.landingDto, this.bpgCommonService.tokenizedHeader())
            .pipe(map((data: any) => {
                return data;

            })).pipe(catchError((error: any) => {
                throw of(error);
            }))
    }


    /** For service call to get skills
 * @class MembershipService
 * @method skills
 * @param landingData
 * @returns Observable
 */
    public getSkills(): Observable<any> {
        return this.http.post(this.URI + this.skillsApi, this.landingDto, this.bpgCommonService.tokenizedHeader())
            .pipe(map((data: any) => {
                return data;

            })).pipe(catchError((error: any) => {
                throw of(error);
            }))
    }


    /** For service call to get demographics
   * @class MembershipService
   * @method demographics
   * @param landingData
   * @returns Observable
   */
    public getDemographics(): Observable<any> {
        return this.http.post(this.URI + this.demographicApi, this.landingDto, this.bpgCommonService.tokenizedHeader())
            .pipe(map((data: any) => {
                return data;

            })).pipe(catchError((error: any) => {
                throw of(error);
            }))
    }


    /** For service call to save membershipform
   * @class MembershipService
   * @method saveMembershipForm
   * @param finalFormData
   * @returns Observable
   */
    public saveMembershipForm(formData): Observable<any> {
        return this.http.post(this.URI + this.membershipFormSaveApi, formData, this.bpgCommonService.tokenizedHeader())
            .pipe(map((data: any) => {
                return data;
            })).pipe(catchError((error: any) => {
                throw of(error);
            }))
    }

    /** For service call to retrieve membershipform
      * @class MembershipService
      * @method retrieveDetailsOfMembership
      * @param userId
      * @returns Observable
      */
    public retrieveDetailsOfMembership(userId): Observable<any> {
        return this.http.post(this.URI + this.retrieveDetailsOfMembershipForm + userId, {}, this.bpgCommonService.tokenizedHeader())
            .pipe(map((data: any) => {
                return data;
            })).pipe(catchError((error: any) => {
                throw of(error);
            }))
    }

    /** For service call to retrieve user details in membership group singup
      * @class MembershipService
      * @method retrieveUserDetails
      * @param workdayId/badgeId
      * @returns Observable
      */
    public fetchUserDetialsForMembershipGroupSignUp(userData): Observable<any> {
        return this.http.post(this.URI + this.retrieveUserDetailsOfGroupMembership, userData, this.bpgCommonService.tokenizedHeader())
            .pipe(map((data: any) => {
                return data;
            })).pipe(catchError((error: any) => {
                throw of(error);
            }))
    }

        /** For service call to save user details in membership group singup
      * @class MembershipService
      * @method saveUserDetails
      * @param userbpgdata
      * @returns Observable
      */
        public saveUserDetialsForMembershipGroupSignUp(membershipData): Observable<any> {
            return this.http.post(this.URI + this.saveUserDetailsOfGroupMembership, membershipData, this.bpgCommonService.tokenizedHeader())
                .pipe(map((data: any) => {
                    return data;
                })).pipe(catchError((error: any) => {
                   throw of(error);
                }))
        }

          /** For service call to save bpg settings in membership group singup
      * @class MembershipService
      * @method saveBpgSettings
      * @param bpgSettingsData
      * @returns Observable
      */
        public saveBpgSettingsForAdmin(bpgSettingsData): Observable<any> {
            return this.http.post(this.URI + this.saveAdminBpgSettings, bpgSettingsData, this.bpgCommonService.tokenizedHeader())
                .pipe(map((data: any) => {
                    return data;
                })).pipe(catchError((error: any) => {
                    throw of(error);
                }))
        }

          /** For service call to fetch past enrollments data in membership group singup
      * @class MembershipService
      * @method fetchPastEnrollmentsData
      * @param userId
      * @returns Observable
      */
        public fetchPastEnrollmentsData(userId): Observable<any> {
            return this.http.get(this.URI + this.pastEnrollmentListApi + userId,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
                return data;
          
              }))
                .pipe(catchError((error: any) => {
                  throw of(error);
                }))
          }

           /** For service call to delete enrollmentin membership group singup
      * @class MembershipService
      * @method deleteEnrollment
      * @param mappingId
      * @returns Observable
      */
          public deleteEnrollment(mappingId): Observable<any> {

            return this.http.delete(this.URI + this.enrollmentDeleteApi + mappingId, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
              return data;
        
            }))
              .pipe(catchError((error: any) => {
                throw of(error);
              }))
          }
}
